import { kebabCase } from 'lodash';
import { FieldTypes } from 'components/organisms/module-settings/fields/types';
import { pascalCase } from 'utils/pascal-case';
import { unreachable } from 'utils/unreachable';
import { SelectFilterOperationType, valueFromString, valueToString } from './select';
import { TermSeparator } from './separators';
const isValid = (filter)=>{
    switch(filter.type){
        case SelectFilterOperationType.Is:
        case SelectFilterOperationType.IsNot:
        case SelectFilterOperationType.IsOneOf:
        case SelectFilterOperationType.IsNoneOf:
            var _filter_value;
            return ((_filter_value = filter.value) !== null && _filter_value !== void 0 ? _filter_value : []).length > 0;
        default:
            return true;
    }
};
export const isOptional = (type)=>type === SelectFilterOperationType.IsEmpty || type === SelectFilterOperationType.IsNotEmpty;
const to = valueToString((x)=>{
    if (typeof x === 'number') {
        return x.toString();
    }
    return String(x);
});
const from = valueFromString((x)=>{
    const result = parseInt(x, 10);
    return Number.isNaN(result) || Number.isNaN(Number(x)) ? x : result;
});
const toString = (filter)=>{
    const type = kebabCase(filter.type);
    switch(filter.type){
        case SelectFilterOperationType.IsEmpty:
        case SelectFilterOperationType.IsNotEmpty:
            return type;
        case SelectFilterOperationType.Is:
        case SelectFilterOperationType.IsNot:
        case SelectFilterOperationType.IsNoneOf:
        case SelectFilterOperationType.IsOneOf:
            var _filter_value;
            return [
                type,
                to((_filter_value = filter.value) !== null && _filter_value !== void 0 ? _filter_value : [])
            ].join(TermSeparator);
        default:
            return unreachable(filter);
    }
};
const parse = (value, field)=>{
    const [type_string, meta] = value.split(TermSeparator);
    const type = pascalCase(type_string);
    switch(type){
        case SelectFilterOperationType.IsEmpty:
        case SelectFilterOperationType.IsNotEmpty:
            return {
                field,
                type
            };
        case SelectFilterOperationType.Is:
        case SelectFilterOperationType.IsNot:
        case SelectFilterOperationType.IsOneOf:
        case SelectFilterOperationType.IsNoneOf:
            return {
                field,
                type,
                value: from(meta)
            };
        case SelectFilterOperationType.IsAtLeast:
        case SelectFilterOperationType.IsAtMost:
        default:
            return unreachable(`${type} cannot be parsed for ${field.type} field`);
    }
};
export const MultiSelectFieldFilter = {
    isValid,
    toString,
    parse
};
export const isMultiSelectFieldFilter = (arg)=>arg.field.fieldType === FieldTypes.MultiSelect;
export const isMultiSelectFilterWithValue = (arg)=>[
        SelectFilterOperationType.Is,
        SelectFilterOperationType.IsNot,
        SelectFilterOperationType.IsNoneOf,
        SelectFilterOperationType.IsOneOf
    ].includes(arg.type);
